/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Begin_FailedInputs */



/**
* | output |
* | --- |
* | "We could not start the practice conversation. Please try again." |
*
* @param {Practice_Session_Begin_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_begin_failed = /** @type {((inputs?: Practice_Session_Begin_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Begin_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden het oefengesprek niet starten. Probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu démarrer l'entretien. Réessayez.")
	return /** @type {LocalizedString} */ ("We could not start the practice conversation. Please try again.")
});